import { store } from "./../redux"

class ApiService {
	static getAccessToken() {
		const { authentication: { accessToken, tokenType } } = store.getState();
		return accessToken !== null ? `${tokenType} ${accessToken}` : undefined
	}

	static getBaseUrl() {
		return `${process.env.REACT_APP_API_URL || `${window.location.origin}/api/v2`}`
	}

	static objectToFormData(object) {
		const formData = new FormData()
		Object.keys(object).forEach(key => formData.append(key, object[key]))
		return formData
	}
}

export default ApiService



// WEBPACK FOOTER //
// ./src/api/ApiService.js